module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.showCartInfo ? 'show' : '',
    attrs: {
      "id": "cartInfo"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeCartInfo.apply(null, arguments)
      }
    }
  }, [_c('div', {
    class: _vm.showCartInfo ? 'cart show' : 'cart',
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.showCartInfo) ? _c('div', {
    staticClass: "cart-info"
  }, [(_vm.showType != 'packageTotalSales' && _vm.showType != 'empSalesInfo' && _vm.showType != 'secondActivity') ? _c('span', {
    staticClass: "table-info"
  }, [_vm._v(_vm._s(_vm.nowSelName) + "-" + _vm._s(_vm.titInfo[_vm.showType]))]) : _vm._e(), _vm._v(" "), (_vm.showType == 'packageTotalSales') ? _c('span', {
    staticClass: "table-info"
  }, [_vm._v(_vm._s(_vm.nowPackageTotalSalesInfo.packName))]) : _vm._e(), _vm._v(" "), (_vm.showType == 'empSalesInfo') ? _c('span', {
    staticClass: "table-info"
  }, [_vm._v("员工姓名:" + _vm._s(_vm.nowEmpSalesInfo.empName))]) : _vm._e(), _vm._v(" "), (_vm.showType == 'secondActivity') ? _c('span', {
    staticClass: "table-info"
  }, [_vm._v("优惠详情")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeCartInfo.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-guanbi1"
  })])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'orderInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "cart-info"
  }, [_c('span', {
    staticClass: "table-info"
  }, [_vm._v(_vm._s(((_vm.orderInfo.transaction.partitionName) + "-" + (_vm.orderInfo.transaction.numName))))]), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeCartInfo.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-guanbi1"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "common-wrap"
  }, [(_vm.showType == 'secondActivity' && _vm.showCartInfo) ? _c('div', {
    staticClass: "cart-detail"
  }, [_c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("活动名称")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.secondInfo.name))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("创建时间")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(_vm.secondInfo.addTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("优惠方式")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.typeOptions[_vm.secondInfo.discountType]))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("减免金额/折扣")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.formatDiscount(_vm.secondInfo)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("生效时间")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.formatTime(_vm.secondInfo)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("时间范围")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.formatTimeRange(_vm.secondInfo)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item all-width"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("星期")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.secondInfo.week))])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'vipChargeInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "cart-detail"
  }, [_c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("充值单号:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipInfo.orderCode))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("充值时间:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(_vm.vipInfo.chargeTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员卡号:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipInfo.memberCode))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员姓名:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipInfo.memberName))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员级别:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipInfo.memberLevel))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员手机:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipInfo.memberMobile))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("充前余额:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipInfo.beforeAmount.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("充值金额:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipInfo.chargeAmount.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("赠送金额:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipInfo.bonusAmount.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员余额:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipInfo.afterAmount.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("备注:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipInfo.notice))])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'empSalesInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "cart-detail"
  }, [_c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("开始时间:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.nowEmpSalesInfo.beginTime))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("结束时间:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.nowEmpSalesInfo.endTime))])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'deskSalesInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "cart-detail"
  }, [_c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("开台时间:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(_vm.nowDeskSalesInfo.begin)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("关台时间:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(_vm.nowDeskSalesInfo.end)))])]), _vm._v(" "), (_vm.nowDeskSalesInfo.memberName) ? _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员姓名:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.memberName))])]) : _vm._e(), _vm._v(" "), (_vm.nowDeskSalesInfo.memberMobile) ? _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员手机号:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.memberMobile))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("累计时长:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.totalTime))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("顾客人数:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.people))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("开单员工:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.openEmp))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("商品消费:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.totalAmount) + "元")])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("包间费:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.totalRoomAmount) + "元")])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'vipConsume' && _vm.showCartInfo) ? _c('div', {
    staticClass: "cart-detail"
  }, [_c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("结账编号:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipConsumeInfo.order.code))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("开单员工:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipConsumeInfo.order.creatorName))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("开单时间:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(_vm.vipConsumeInfo.order.addTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("结账时间:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(_vm.vipConsumeInfo.order.paymentTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("累积时长:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipConsumeInfo.transaction.inTime))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("顾客人数:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipConsumeInfo.transaction.people))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("结账员工:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipConsumeInfo.order.payName))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员编号:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipConsumeInfo.order.memberName))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员姓名:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipConsumeInfo.order.memberName))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("是否免单:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipConsumeInfo.order.mode == 1 ? "是" : "否"))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("是否挂单:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipConsumeInfo.order.mode == 2 ? "是" : "否"))])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'orderInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "cart-detail"
  }, [_c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("结账编号:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.orderInfo.order.id))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("开单员工:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.orderInfo.transaction.empName))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("开单时间:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(new Date(_vm.orderInfo.order.addTime).Format('yyyy-MM-dd hh:mm:ss')))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("结账时间:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(new Date(_vm.orderInfo.order.paymentTime).Format('yyyy-MM-dd hh:mm:ss')))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("累计时长:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.orderInfo.transaction.inTime))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("顾客人数:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.orderInfo.transaction.people) + "人")])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("结账员工:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.orderInfo.order.payName))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员编号:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.orderInfo.order.memberId ? _vm.orderInfo.order.memberId : "-"))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员姓名:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.orderInfo.order.memberId ? _vm.orderInfo.order.memberName : "-"))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("是否免单:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.orderInfo.order.mode == 1 ? '是' : '否'))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("是否挂单:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.orderInfo.order.mode == 2 ? '是' : '否'))])])]) : _vm._e(), _vm._v(" "), (_vm.showType != 'packageTotalSales') ? _c('div', {
    staticClass: "split-line",
    attrs: {
      "data-v-1e65f96a": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showType == 'orderInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "note"
  }, [_c('span', [_vm._v("备注：" + _vm._s(_vm.orderInfo.order.notes ? _vm.orderInfo.order.notes : '无'))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cart-goods-detail"
  }, [(_vm.showType == 'secondActivity' && _vm.showCartInfo) ? _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("参与优惠的商品")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(2), _vm._v(" "), _vm._l((_vm.goodsInfoForSecond.content), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(item.discountCommission / 100))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(item.count))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.nowPage,
      "page-size": _vm.pageSize,
      "layout": "prev, pager, next, jumper",
      "total": _vm.totalElements
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.nowPage = $event
      },
      "update:current-page": function($event) {
        _vm.nowPage = $event
      }
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'secondActivity' && _vm.showCartInfo) ? _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("活动日志")]), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "时间选择:"
    }
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "00:00:00",
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.formInline.startTime),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "startTime", $$v)
      },
      expression: "formInline.startTime"
    }
  }), _vm._v(" "), _c('span', [_vm._v("至")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "23:59:59",
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.formInline.endTime),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "endTime", $$v)
      },
      expression: "formInline.endTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(3), _vm._v(" "), _vm._l((_vm.salesGoodsInfo.content), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(item.orderId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(_vm._f("numberToAllDate")(item.payTime)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(item.qty))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.nowPageForSales,
      "page-size": _vm.pageSizeForSales,
      "layout": "prev, pager, next, jumper",
      "total": _vm.totalElementsForSales
    },
    on: {
      "current-change": _vm.handleCurrentChangeForSales,
      "update:currentPage": function($event) {
        _vm.nowPageForSales = $event
      },
      "update:current-page": function($event) {
        _vm.nowPageForSales = $event
      }
    }
  })], 1)])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showType == 'vipChargeInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(4), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.channelType[_vm.vipInfo.channel]))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.vipInfo.chargeAmount))])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'vipConsume' && _vm.showCartInfo) ? _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("收入明细")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(5), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("商品费")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.vipConsumeInfo.productAmount).toFixed(2)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.vipConsumeInfo.productDiscount).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("包间费")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.vipConsumeInfo.transaction.roomAmount).toFixed(2)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.vipConsumeInfo.transaction.roomDiscount).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("服务费")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.vipConsumeInfo.transaction.serviceAmount).toFixed(2)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.vipConsumeInfo.transaction.serviceDiscount).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("手动优惠")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.vipConsumeInfo.order.allHandDiscount).toFixed(2)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("--")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("消费明细")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(6), _vm._v(" "), _vm._l((_vm.vipConsumeInfo.order.items), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.onePrice))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.dealPrice))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.createName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(_vm.vipConsumeInfo.order.mode == 0 ? '正常' : (_vm.vipConsumeInfo.order.mode == 1 ? '免单' : '挂单')))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(new Date(item.addTime).Format('yyyy-MM-dd hh:mm:ss')))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("付款信息")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(7), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.channelType[_vm.vipConsumeInfo.order.channel]))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s((_vm.vipConsumeInfo.order.amount).toFixed(2)))])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'orderInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("收入明细")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(8), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("商品费")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.orderInfo.productAmount).toFixed(2)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.orderInfo.productDiscount).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("包间费")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s(Number(Number(_vm.orderInfo.transaction.roomAmount) - Number(_vm.orderInfo.transaction.roomDiscount)).toFixed(2)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.orderInfo.transaction.roomDiscount).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("服务费")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s(Number(Number(_vm.orderInfo.transaction.serviceAmount) - Number(_vm.orderInfo.transaction.serviceDiscount)).toFixed(2)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.orderInfo.transaction.serviceDiscount).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("手动优惠")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.orderInfo.order.allHandDiscount).toFixed(2)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("--")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("商品消费清单")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(9), _vm._v(" "), _vm._l((_vm.orderInfo.order.items), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.onePrice))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.dealPrice))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.createName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(_vm.modeInfo[_vm.orderInfo.order.mode]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(new Date(item.addTime).Format('yyyy-MM-dd hh:mm:ss')))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("计时商品消费清单")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(10), _vm._v(" "), _vm._l((_vm.orderInfo.productTime), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(item.productTimeName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(item.ruleName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.createName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(new Date(item.addTime).Format('yyyy-MM-dd hh:mm:ss')))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("包间费清单")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(11), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(((_vm.orderInfo.transaction.partitionName) + "-" + (_vm.orderInfo.transaction.numName))))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(_vm.orderInfo.transaction.beginTime)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.transaction.inTime))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.transaction.rulesName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.transaction.roomAmount))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("付款信息")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(12), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.channelType[_vm.orderInfo.order.channel]))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s((_vm.orderInfo.order.amount).toFixed(2)))])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'exchangeInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("分类销售统计")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('div', {
    staticClass: "for-goods"
  }, [_vm._m(13), _vm._v(" "), _vm._l((_vm.nowExcInfo.itemDetails), function(it, idx) {
    return _c('div', {
      key: idx,
      staticClass: "goods-detail",
      class: _vm.nowSelIndex == idx ? 'act' : ''
    }, [_c('div', {
      staticClass: "detail-tit",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showGoodsDetail(it, idx)
        }
      }
    }, [_c('div', {
      staticClass: "detail-tit-span",
      staticStyle: {
        "width": "33.333%",
        "text-align": "left",
        "padding-left": "15px"
      }
    }, [_c('i', {
      staticClass: "arrow iconfont icon-sanjiaoxing",
      staticStyle: {
        "vertical-align": "middle",
        "font-size": "10px",
        "margin-right": "5px"
      }
    }), _c('span', {
      staticStyle: {
        "vertical-align": "middle",
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(it.typeName))])]), _vm._v(" "), _c('div', {
      staticClass: "detail-tit-span",
      staticStyle: {
        "width": "33.333%"
      }
    }, [_vm._v(_vm._s(it.qty))]), _vm._v(" "), _c('div', {
      staticClass: "detail-tit-span",
      staticStyle: {
        "width": "33.333%"
      }
    }, [_vm._v(_vm._s(it.amount.toFixed(2)))]), _vm._v(" "), _vm._l((_vm.itemDetail), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "goods",
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_c('div', {
        staticClass: "goods-span",
        staticStyle: {
          "width": "33.33%",
          "cursor": "pointer"
        }
      }, [_c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
        staticClass: "goods-span",
        staticStyle: {
          "width": "33.33%"
        }
      }, [_vm._v(_vm._s(item.qty))]), _vm._v(" "), _c('div', {
        staticClass: "goods-span",
        staticStyle: {
          "width": "33.33%"
        }
      }, [_vm._v(_vm._s(item.amount.toFixed(2)))])])
    })], 2)])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'empSalesInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("详情")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(14), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("会员充值")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s((_vm.nowEmpSalesInfo.memberCharge).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("总销售")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(Number(_vm.nowEmpSalesInfo.salesTotal).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("会员消费")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(Number(_vm.nowEmpSalesInfo.totalMember).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("推荐会员数")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.nowEmpSalesInfo.memberCount))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("总开台次数")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.nowEmpSalesInfo.openNum))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("预定次数")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.nowEmpSalesInfo.bookNum))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("商品销售列表")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('div', {
    staticClass: "for-goods"
  }, [_vm._m(15), _vm._v(" "), _vm._l((_vm.nowEmpSalesInfo.items), function(it, idx) {
    return _c('div', {
      key: idx,
      staticClass: "goods-detail"
    }, [_c('div', {
      staticClass: "detail-tit",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showGoodsDetail(it, idx)
        }
      }
    }, [_c('div', {
      staticClass: "detail-tit-span",
      staticStyle: {
        "width": "33.333%",
        "text-align": "left",
        "padding-left": "15px"
      }
    }, [_c('i', {
      staticClass: "arrow iconfont icon-sanjiaoxing",
      staticStyle: {
        "vertical-align": "middle",
        "font-size": "10px",
        "margin-right": "5px"
      }
    }), _c('span', {
      staticStyle: {
        "vertical-align": "middle",
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(it.name))])]), _vm._v(" "), _c('div', {
      staticClass: "detail-tit-span",
      staticStyle: {
        "width": "33.333%"
      }
    }, [_vm._v(_vm._s(it.qty))]), _vm._v(" "), _c('div', {
      staticClass: "detail-tit-span",
      staticStyle: {
        "width": "33.333%"
      }
    }, [_vm._v(_vm._s(it.amount.toFixed(2)))]), _vm._v(" "), _vm._l((it.items), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "goods",
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_c('div', {
        staticClass: "goods-span",
        staticStyle: {
          "width": "33.33%",
          "cursor": "pointer"
        }
      }, [_c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
        staticClass: "goods-span",
        staticStyle: {
          "width": "33.33%"
        }
      }, [_vm._v(_vm._s(item.qty))]), _vm._v(" "), _c('div', {
        staticClass: "goods-span",
        staticStyle: {
          "width": "33.33%"
        }
      }, [_vm._v(_vm._s(item.amount.toFixed(2)))])])
    })], 2)])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'packageTotalSales' && _vm.showCartInfo) ? _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("商品列表")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(16), _vm._v(" "), _vm._l((_vm.nowPackageTotalSalesInfo.itemQties), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.qty))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("商品消费清单")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(17), _vm._v(" "), _vm._l((_vm.nowPackageTotalSalesInfo.resList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(item.amount.toFixed(2)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(item.qty))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(item.numName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "16%"
      }
    }, [_vm._v(_vm._s(item.createName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(_vm._f("naSecFilterDate")(item.addTime)))])])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'deskSalesInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("商品消费清单")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(18), _vm._v(" "), _vm._l((_vm.nowDeskSalesInfo.orderItems), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(item.dealPrice.toFixed(2)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "16%"
      }
    }, [_vm._v(_vm._s(item.createName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(item.addTime)))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("包间费清单")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(19), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.numName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(_vm.nowDeskSalesInfo.begin)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(_vm.nowDeskSalesInfo.end)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.totalTime))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.rulesName ? _vm.nowDeskSalesInfo.rulesName : '--'))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.totalRoomAmount))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("付款信息")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(20), _vm._v(" "), _vm._l((_vm.nowDeskSalesInfo.channel), function(ite, indx) {
    return _c('tr', {
      key: indx
    }, [_c('td', {
      staticStyle: {
        "width": "33.333%"
      }
    }, [_vm._v(_vm._s(indx + 1))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "33.333%"
      }
    }, [_vm._v(_vm._s(_vm.channelType[ite.channel]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "33.333%"
      }
    }, [_vm._v(_vm._s(ite.channel ? Number(ite.amount).toFixed(2) : ''))])])
  })], 2)])])]) : _vm._e()])]), _vm._v(" "), (_vm.showType == 'vipConsume' && _vm.showCartInfo) ? _c('div', {
    staticClass: "add-or-pay-wrap"
  }, [_c('span', {
    staticClass: "total-fee"
  }, [_vm._v("\n        合计:\n        "), _c('b', [_vm._v(_vm._s((Number(_vm.vipConsumeInfo.order.amount)).toFixed(2)))]), _vm._v("元\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'deskSalesInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "add-or-pay-wrap"
  }, [_c('span', {
    staticClass: "total-fee"
  }, [_vm._v("\n        合计:\n        "), _c('b', [_vm._v(_vm._s((Number(_vm.nowDeskSalesInfo.totalAmount) + Number(_vm.nowDeskSalesInfo.totalRoomAmount)).toFixed(2)))]), _vm._v("元\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'orderInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "add-or-pay-wrap"
  }, [_c('span', {
    staticClass: "total-fee"
  }, [_vm._v("\n        合计:\n        "), _c('b', [_vm._v(_vm._s((Number(_vm.orderInfo.order.amount)).toFixed(2)))]), _vm._v("元\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'secondActivity' && _vm.showCartInfo && (_vm.secondInfo.promotionType == 'ing' || _vm.secondInfo.promotionType == 'no')) ? _c('div', {
    staticClass: "add-or-pay-wrap"
  }, [_c('div', {
    staticClass: "add-or-pay"
  }, [_c('button', {
    staticClass: "go-pay",
    staticStyle: {
      "background": "#d99e4c"
    },
    on: {
      "click": _vm.cancelActivity
    }
  }, [_vm._v("取消活动")])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("排序")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("提成金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("销售数量")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("消费单号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("销售时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("销售数量")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("付款方式")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("金额(元)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "33.33%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33.33%"
    }
  }, [_vm._v("金额(元)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33.33%"
    }
  }, [_vm._v("优惠")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("单价")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("点单员工")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("状态")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("点单时间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("金额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("优惠")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("单价")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("点单员工")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("状态")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("点单时间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("计时规则")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("点单员工")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("计时时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("点单时间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("包间名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("开始时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("入座时长")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("计费规则")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("包间费")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("金额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "span",
    staticStyle: {
      "width": "33.333%"
    }
  }, [_vm._v("商品分类")]), _vm._v(" "), _c('div', {
    staticClass: "span",
    staticStyle: {
      "width": "33.333%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('div', {
    staticClass: "span",
    staticStyle: {
      "width": "33.333%"
    }
  }, [_vm._v("应收金额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("金额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "span",
    staticStyle: {
      "width": "33.333%"
    }
  }, [_vm._v("商品分类")]), _vm._v(" "), _c('div', {
    staticClass: "span",
    staticStyle: {
      "width": "33.333%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('div', {
    staticClass: "span",
    staticStyle: {
      "width": "33.333%"
    }
  }, [_vm._v("应收金额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("数量")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("台桌名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v("操作员")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("时间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v("操作员")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("时间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("包间名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("开始时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("结束时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("入座时长")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("计费规则")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("包间费")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "33.333%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33.333%"
    }
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33.333%"
    }
  }, [_vm._v("金额")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4919c285","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/cartInfo/cartInfo.vue
// module id = 943
// module chunks = 1